import checkoutFormModel from "./components/CheckoutFormModel/checkoutFormModel";

const {
  formField: {
    address,
    postCode,
    city,
    shipping: {
      shippingPostCode,
      shippingCity,
      shippingAddress,
      shippingAddress2,
    },
  },
} = checkoutFormModel;

export const getFormattedPrice = (price) => {
  return new Intl.NumberFormat("da-DK", {
    currency: "DKK",
    style: "currency",
  }).format(price);
};

export const getSkiltLines = ({
  line1Part1,
  line1Part2,
  line2Part1,
  line2Part2,
}) => {
  const lines = [];
  if (line1Part1 || line1Part2) {
    lines.push([line1Part1, line1Part2].join(" ").trimEnd());
  }
  if (line2Part1 || line2Part2) {
    lines.push([line2Part1, line2Part2].join(" ").trimEnd());
  }
  return lines;
};

export const getContrast = (hexcolor) => {
  if (!hexcolor) return null;
  // If a leading # is provided, remove it
  if (hexcolor.slice(0, 1) === "#") {
    hexcolor = hexcolor.slice(1);
  }

  if (hexcolor.length === 3) {
    hexcolor = hexcolor
      .split("")
      .map((hex) => hex + hex)
      .join("");
  }

  // Convert to RGB value
  var r = parseInt(hexcolor.substr(0, 2), 16);
  var g = parseInt(hexcolor.substr(2, 2), 16);
  var b = parseInt(hexcolor.substr(4, 2), 16);

  // Get YIQ ratio
  var yiq = (r * 299 + g * 587 + b * 114) / 1000;

  // Check contrast
  return yiq >= 128
    ? { label: "sort", hex: "#000000" }
    : { label: "hvid", hex: "#ffffff" };
};

export const getAddress = (values) => {
  let str = "";
  if (values[shippingAddress.name]) {
    str += values[shippingAddress.name];
    if (values[shippingAddress2.name]) {
      str += ", " + values[shippingAddress2.name];
    }
    str +=
      ", " + values[shippingPostCode.name] + " " + values[shippingCity.name];
  } else {
    str = `${values[address.name]}, ${values[postCode.name]} ${
      values[city.name]
    }`;
  }

  return str;
};

export const getTotalPriceInfo = (data) => {
  const totalPrice = data.reduce((acc, el) => {
    const price =
      typeof el.item.price === "string"
        ? parseFloat(el.item.price)
        : el.item.price;
    return acc + price * el.qty;
  }, 0);
  const totalNoVat = data.reduce((acc, el) => {
    const price =
      typeof el.item.priceNoVat === "string"
        ? parseFloat(el.item.priceNoVat)
        : el.item.priceNoVat;
    return acc + price * el.qty;
  }, 0);

  return {
    totalPrice,
    totalNoVat,
  };
};

export const getColors = (data) => {
  return (
    (data &&
      data.options.skilt_farve &&
      data.options.skilt_farve.values &&
      data.options.skilt_farve.values.map((item) => ({
        hex: item.value,
        label: item.label,
      }))) ||
    []
  );
};

export function isInViewport(element) {
  const rect = element.getBoundingClientRect();

  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.top <= (window.innerHeight || document.documentElement.clientHeight) &&
    rect.left <= (window.innerWidth || document.documentElement.clientWidth)
  );
}

export function makeAjaxCall({
  url,
  method = "GET",
  data,
  toJson = true,
  noSpinner = false,
  notifyFailure = true,
  $spinnerComponent = null,
  isGlobal = true,
  isAsync = true,
  signal,
  crossDomain = false,
  notifySuccess = true,
}) {
  return new Promise((resolve, reject) => {
    const request = make_ajax_call_helper(
      url,
      method,
      data,
      function (json) {
        resolve(json);
      },
      function (res, errMessage, errorThrown) {
        reject({ res, errMessage, errorThrown });
      },
      toJson,
      noSpinner,
      notifyFailure,
      $spinnerComponent,
      isGlobal,
      isAsync,
      crossDomain,
      notifySuccess
    );
    signal?.addEventListener("abort", () => {
      request.abort();
      reject("Aborted");
    });
  });
}

export const isProductDataWithOptions = (data) =>
  data?.options && "videx_skilt_billede" in data.options;
